<template>
  <vx-card class="mt-base" title="Law Activity 11 - Criminal Case Scenario - Part #2">
    <h4 class="mb-5">The Arguments</h4>
    <p class="mb-5">
      Watch this next video in the Criminal Case Scenario series. It outlines what the prosecution
      will argue in the case and what might be the case for the defence. You’ll learn how to
      practise applying the facts of a case to the elements of the offence of dangerous driving
      causing death. The role of the jury is also outlined.
    </p>
    <centered-image-wrapper
      :image="videos[1].image"
      classes="2/3"
      label="Play video: Criminal Trial, Episode 2"
      @clicked="showIframePopup(videos[1].video)"
    />

    <h4 class="mb-5">1. The Case for the Prosecution</h4>
    <p class="mb-5">
      In the video, Crown Prosecutor Fran Dalziel notes the prosecutor will need to make it clear to
      the jury that they don’t need to find that the accused deliberately did something wrong, but
      that in all the circumstances, the driving was dangerous. From the list below, select the two
      behaviours of the accused that the prosecution would use to establish this. You can re-watch
      the video as needed.
    </p>
    <div v-for="(question, index) in questions1" :key="'1_' + index">
      <chechbox-buttons-wrapper
        v-model="answers['question1']"
        :index="index + 1"
        :question="question"
        :is-editable="isEditable"
      />
    </div>

    <h4 class="mb-5">2. The Case for the Defence</h4>
    <p class="mb-5">
      According to Sarah Keating, there are three main elements to this case. Which element did
      Sarah Keating argue that the defence should focus on and why?
    </p>
    <div v-for="(question, index) in questions2" :key="'2_' + index">
      <chechbox-buttons-wrapper
        v-model="answers['question2']"
        :index="index + 1"
        :question="question"
        :is-editable="isEditable"
      />
    </div>
    <h4 class="mb-5">Why?</h4>
    <p class="mb-5">
      The defence should focus on the fact that the cyclist approached the roundabout at speed. They
      should raise the question: Can the prosecution exclude the speed at which the rider was
      travelling as the cause of the accident and point beyond a reasonable doubt that it was the
      driver’s attention on the mobile phone that caused the accident?
    </p>
    <h4 class="mb-5">3. Have Your Say!</h4>
    <p class="mb-5">
      Imagine you are a member of the jury. Do you think the accused will be found guilty of the
      offence of dangerous driving causing death? Why do you think this will be the outcome? Refer
      to the three elements of this offence in your discussion.
    </p>
    <textarea-block v-model="answers.question3" :editable="isEditable" />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import ChechboxButtonsWrapper from '@/views/WorkExperiences/components/ActivitiesBlocks/ChechboxButtonsWrapper';

export default {
  components: { ChechboxButtonsWrapper },
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/law/criminal_case_part_2_splash.jpg'),
          video: 'https://www.youtube.com/embed/YvC-grbF3HQ',
        },
      },
      questions1: [
        {
          answers: [
            { val: 1, answer: 'The driver was driving at an unsafe speed', correct: true },
            { val: 2, answer: 'The driver’s car was not roadworthy', correct: false },
            { val: 3, answer: 'The driver was distracted by his mobile phone', correct: true },
            {
              val: 4,
              answer: 'The driver was unlicensed at the time of the incident',
              correct: false,
            },
            { val: 5, answer: 'The driver was not paying attention to the road', correct: false },
          ],
        },
      ],
      questions2: [
        {
          answers: [
            { val: 1, answer: 'Accused was driving a motor vehicle', correct: false },
            { val: 2, answer: 'Accused drove dangerously', correct: false },
            { val: 3, answer: 'Dangerous driving caused the death', correct: true },
          ],
        },
      ],
      answers: {
        question1: [],
        question2: [],
        question3: '',
      },
    };
  },
  methods: {
    save() {
      this.data = this.answers;
      this.saveActivity(this.$route.params.slug, this.data);
    },
  },
  computed: computed,
  inject: inject,
  mounted() {
    for (let i = 1; i <= Object.keys(this.answers).length; i++) {
      if (typeof this.data['question' + i] !== 'undefined') {
        this.answers['question' + i] = this.data['question' + i];
      }
    }
  },
};
</script>
